//
// Copyright (c) 2011-2020 by Curalate, Inc.
//

import {
  IGetContextualShowroomRequest,
  IGetContextualShowroomResponse,
  IGetShowroomShortLinkRequest,
  IGetShowroomShortLinkResponse,
} from '@apis/showroom/showroomApiModel';
import { sessionFetch } from '@utils/sessionFetch';

const showroomFetch = (endpoint: string, init?: RequestInit) => {
  return sessionFetch(`/api/showroom${endpoint}`, init);
};

/**
 * Gets a shortened showroom link for given showroom data
 *
 * POST /api/showroom/short-link
 */
export const getShowroomShortLink = async (
  req: IGetShowroomShortLinkRequest,
): Promise<IGetShowroomShortLinkResponse> => {
  const res = await showroomFetch(`/short-link`, {
    method: 'POST',
    body: JSON.stringify(req),
  });
  return res.json();
};

/**
 * Gets the contextual showroom tied to the given url or creates one if none exists.
 * Throws an error if the url is not tied to any showroom.
 *
 * POST /api/showroom/contextual-showroom
 */
export const getContextualShowroom = async (
  req: IGetContextualShowroomRequest,
): Promise<IGetContextualShowroomResponse> => {
  const res = await showroomFetch(`/contextual-showroom`, {
    method: 'POST',
    body: JSON.stringify(req),
  });
  return res.json();
};
